module.exports = __webpack_public_path__ + "img/mark2_d.a39a4522.png";